<template>
    <form action="" method="post" enctype="multipart/form-data" class="mojafirma_logo mt-4" >
        <input type="file" name="files" ref="file" class="files"  
            :data-fileuploader-files='preloadedfiles'
            />
    </form>
</template>

<script>
    export default {
        props: ['preloadedfiles'],
        data() {
            return {
                file: null,
            }
        },
        methods: {
            sendData(){
                this.$emit('getDataLogo', this.file);
            }
        },
        mounted () {
            var t = this
            $(document).ready(function() {
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                    }
                });
                $(".mojafirma_logo input.files").fileuploader({
                    limit: 1,
                    extensions: ["jpg", "png", "svg"],
                    fileMaxSize: 2,
                    changeInput:
                                '<div class="fileuploader-input">' +
                                '<span class="top_left">' + t.$t('mojefirmy.text_40') + '</span>' +  
                                '<div class="fileuploader-input-inner">' +
                                '<div class="fileuploader-icon-main"></div>' +
                                '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                                "<p>${captions.or}</p>" +
                                "</div>" +
                                "</div>",
                    theme: "dragdrop",
                    thumbnails: {
                        onImageLoaded: function(item) {
                            t.file = item.file
                            if (!item.html.find(".fileuploader-action-edit").length)
                                item.html
                                    .find(".fileuploader-action-remove")
                                    .before(
                                        '<button type="button" class="fileuploader-action fileuploader-action-popup fileuploader-action-edit" title="Uraviť">' +
                                            '<i class="fileuploader-icon-edit"></i></button>'
                                    );

                            // hide current thumbnail (this is only animation)
                            if (item.imageIsUploading) {
                                item.image.addClass("fileuploader-loading").html("");
                            }
                            t.sendData()
                        },
                    },
                    editor: {
                        cropper: {
                            showGrid: true
                        }
                    },
                    captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                        feedback: t.$t('mojefirmy.text_31'),  // "Vlož <b>logo firmy</b> presunutím alebo <span class='nahraj'>nahraj logo</span>"
                        feedback2: t.$t('mojefirmy.text_32'),
                        drop: t.$t('mojefirmy.text_33'),
                        or: "",
                        button: "",
                        remove: t.$t('mojefirmy.text_34'),  // "Vymazať"
                        download: t.$t('mojefirmy.text_35'),  // "Stiahnuť"
                        removeConfirmation: t.$t('mojefirmy.text_36'),  // "Naozaj chcete vymazať logo?"
                        errors: {
                            filesLimit: function(e) {
                                t.$toast.warning(t.$t('mojefirmy.text_37'), {
                                    timeout: 5000,
                                });
                            },
                            filesType: function(e) {
                                t.$toast.warning(t.$t('mojefirmy.text_38', {extensions: e.extensions}), {
                                    timeout: 5000,
                                });
                            },
                            fileSize: function(e) {
                                t.$toast.warning(t.$t('mojefirmy.text_39', {name: e.name, size: e.fileMaxSize}), {
                                    timeout: 5000,
                                });
                            }
                        }
                    }),
                    onRemove: function(item) {
                        t.file = null
                        t.sendData();
                    },

                });
            })
        }
    }

</script>

<style lang="scss">
.mojafirma_logo {
    .fileuploader{
        background: transparent;
        margin: 0;
        padding: 0;
    }
    .fileuploader-theme-dragdrop .fileuploader-input{
        position: relative;
        border: 1px dashed #DDE3E8;
        padding: 15px;
        height: 91px;
        .top_left{
            position: absolute;
            left: 15px;
            top: 15px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598A7;
        }
        .fileuploader-input-inner{    
            margin-top: 14px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-icon-main{
        margin: 0;
        font-size: 32px;
    }
    h3.fileuploader-input-caption{
        margin: 0;
        display: block;
        flex: none;
        align-self: center;
        margin-left: 10px;
        font-family: Roboto;
        font-style: normal;
        font-size: 14px;
        line-height: 16px;
         span{
            font-weight: normal;
            color: #263544;
        }
        .nahraj{
            font-weight: 600;
            color: #2ED8B6;
            text-decoration: underline;
        }
    }
    .fileuploader-items .fileuploader-item:last-child{
        margin-bottom: 0px;
    }
    .fileuploader-items .fileuploader-item .column-actions{
        margin: 0 0 0 16px;
    }
    .fileuploader-items{
        background-color: #fff;
    }
}
</style>
<style lang="scss" scoped>
</style>